<section>
  <ng-container *ngIf="isLoading; else loadedTemplate">
    <app-loading [onlyIcon]="true"></app-loading>
  </ng-container>
  <ng-template #loadedTemplate>
    <div class="contracts-next-expiration">
      <h2 class="contracts-next-expiration-title">{{ 'HOME.CONTRACTS_NEXT_EXPIRATION' | i18nextEager }}</h2>
      <div class="contracts-next-expiration-resume">
        <div>
          <h3>{{ 'HOME.THIS_MONTH' | i18nextEager }}</h3>
          <h4>{{ mesActual }}</h4>
        </div>
        <div>
          <h3>{{ 'HOME.TWO_MONTHS' | i18nextEager }}</h3>
          <h4>{{ dosMeses }}</h4>
        </div>
        <div>
          <h3>{{ 'HOME.THREE_MONTHS' | i18nextEager }}</h3>
          <h4>{{ tresMeses }}</h4>
        </div>
      </div>
      <img
        class="contracts-next-expiration-goTo"
        src="/assets/icons/arrow.svg"
        alt="Arrow"
        (click)="handleNavigate()"
      />
      <app-table
        class="contracts-next-expiration-table"
        *ngIf="data"
        [data]="contratosList"
        [colsTable]="colsTable"
        (clickButton)="handleButton($event)"
      ></app-table>
    </div>
  </ng-template>
</section>
